module.exports = __webpack_public_path__ + "img/2-en.72419bc7.png";